import 'babel-polyfill'; // eslint-disable-line
import 'isomorphic-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
// Kind of smelly since importing causes a side effect
import * as logging from '../app/lib/logging'; // eslint-disable-line
import attachErrorListener from '../app/store/addErrorListener';
import Router from './Router';

attachErrorListener();

// Only attempt to render etc if dom node is available.
const domNode = document.getElementById('react-application-mount');

if (domNode) {
  ReactDOM.render(
    <Router />,
    domNode,
  );
}
